import { useGridApiRef } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import React from 'react';
import { useCommitmentReport } from '../../../../hooks/requests/use-commitment-report';
import { useSearchWithSearchParams } from '../../../../hooks/use-search-with-search-params';
import { ReportHeader } from '../../reports-components/ReportHeader';
import { ReportTable } from '../../reports-components/ReportTable';
import { REPORT_TYPES } from '../../reports-page/reports-page-types/report-type';
import { CommitmentUsageReportTable } from './commitment-usage-report-table/CommitmentUsageReportTable';

type CommitmentUsageReportContentProps = {
  reportId?: string;
};

export const CommitmentUsageReportContent: React.FC<CommitmentUsageReportContentProps> = ({ reportId }) => {
  const { data: commitmentReportData, isLoading } = useCommitmentReport(reportId);
  const [searchText, setSearchText] = useSearchWithSearchParams();
  const { report, startDate, endDate, creationDate } = commitmentReportData;
  const apiRef = useGridApiRef();

  return (
    <>
      <ReportHeader reportData={report} startDate={startDate} endDate={endDate} creationDate={creationDate} />
      <ReportTable
        title="Commitment Usage Report"
        placeholder="Enter customer name..."
        exportCsvFileName="Commitment usage report"
        reportCreationDate={creationDate}
        onSearch={(searchValue) => setSearchText(searchValue)}
        reportType={REPORT_TYPES.COMMITMENT_USAGE}
        apiRef={apiRef as React.MutableRefObject<GridApiCommunity>}
      >
        <CommitmentUsageReportTable
          isLoading={isLoading}
          filter={searchText ?? undefined}
          apiRef={apiRef as React.MutableRefObject<GridApiPro>}
          rows={report}
        />
      </ReportTable>
    </>
  );
};
